import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ENTER, COMMA } from '@angular/cdk/keycodes';

import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { AddTagDialogData } from './add-tag-dialog.data';
import { tagsActions } from '@src/store/reducers/tagTypesReducer';

@Component({
    selector : 'add-tag-dialog',
    template: require('./add-tag-dialog.component.html'),
    styles: [require('./add-tag-dialog.component.scss')]
})
export class AddTagDialogComponent implements OnInit {
    public readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    public searchText = '';
    public selectedTag: any;
    public selectedTagType: any = {};
    public tagTypes: any[] = [];

    public packageTags: any[];
    public definedTags: any[];
    public tagsList: any[] = [];
    public tagTypeTags: any = {};
    public addedTags: any[] = [];
    public specialTags: string[] = ["Obsolete"];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: AddTagDialogData,
        private translatePipe: TranslatePipe) {
        this.packageTags = this.data.packageTags;
        this.definedTags = this.data.addedTags;
    }

    public async ngOnInit() {
        const defaultTagType = 'Task';
        if (this.data.store.getState().tagTypes.tagTypes) {
            this.tagTypes = [...this.data.store.getState().tagTypes.tagTypes];
            if (this.tagTypes.length > 0) {
                this.selectedTagType = this.tagTypes.find(tagT => tagT.name === defaultTagType);
                await this.getTagsForTagType(this.selectedTagType.id);
            }
        }
    }

    public async onTagTypeChange(newValue: any) {
        this.selectedTagType = newValue;
        await this.getTagsForTagType(newValue.id);
    }

    public async onAddCustomTag(event: any) {
        const newTag = event.value.trim();
        this.selectedTag = undefined;
        this.searchText = undefined;
        if (newTag && await this.validateTag(newTag)) {
            const tagObj = { name: newTag.trim(), tagTypeId: this.selectedTagType.id };
            await this.addPackageTag(tagObj);
        }
    }

    private async validateTag(tag: any) {
        if (tag.replace(/\s+/g, '') !== '' && !tag.includes(';') && !tag.match('[\u0000-\u001F]')) {
            return true;
        }

        const translations = await this.translatePipe.transform(['ERROR', 'ERROR_INCORRECT_TAG_NAME']);
        this.data.showErrorDialog({
            title: translations['ERROR'],
            text: translations['ERROR_INCORRECT_TAG_NAME']
        });
        return false;
    }

    private async getTagsForTagType(tagTypeId: any) {
        const response = await this.data.store.dispatch({
            type: tagsActions.GET_TAGS_FOR_TAG_TYPE,
            payload: { tagTypeId, pageNumber: 1, pageSize: 1000 }
        });
        const tags = response.data;
        if (tags) {
            this.tagTypeTags[tagTypeId] = [
                ...tags,
                ...(this.tagTypeTags && this.tagTypeTags[tagTypeId] ? this.tagTypeTags[tagTypeId] : [])
            ];
            this.definedTags.forEach((defTag: any) => {
                this.tagTypeTags[tagTypeId] = this.tagTypeTags[tagTypeId]
                    .filter((tag: any) => tag.name !== defTag.name);
            });
            this.tagsList = this.tagTypeTags[tagTypeId];
        }
    }

    private async addPackageTag(pkgTag: any) {
        if (await this.checkIfTagUnique(pkgTag)) {
            this.addedTags.push({ tagTypeId: pkgTag.tagTypeId, name: pkgTag.name });
            if (!this.packageTags[this.selectedTagType.id]) {
                this.packageTags[this.selectedTagType.id] = {
                    tagType: { ...this.selectedTagType }
                };
            }
            const tags = [...this.packageTags[this.selectedTagType.id].tagsList || []];
            this.packageTags[this.selectedTagType.id].tagsList = [...tags, pkgTag];
            this.tagsList = this.tagsList.filter(tag => tag.name !== pkgTag.name);
            this.tagTypeTags[pkgTag.tagTypeId] = [...this.tagsList];
        }
    }

    private async checkIfTagUnique(pkgTag: any) {
        const clean = (name: string) => name.toLowerCase().trim();
        const compareTags = (tag: any) => clean(pkgTag.name) === clean(tag.name) && tag.tagTypeId === pkgTag.tagTypeId;
        if (this.addedTags.findIndex(tag => compareTags(tag)) !== -1
            || this.definedTags.findIndex(tag => compareTags(tag)) !== -1) {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_DUPLICATE_TAG']);
            this.data.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_DUPLICATE_TAG']
            });
            return false;
        }
        return true;
    }

    public async onSelectedTagChanged(selectedTag: any) {
        if (selectedTag) {
            await this.addPackageTag(selectedTag);
            this.selectedTag = undefined;
            this.searchText = undefined;
        }
    }

    public removeTag(tagObj: any) {
        for (const tagTypeId in this.packageTags) {
            const tags = [...this.packageTags[tagTypeId].tagsList];
            const tagToDelete = tags.find(tag => tag.name === tagObj.name);
            if (tagToDelete) {
                if (tagToDelete.name) {
                    this.tagsList.push(tagToDelete);
                }
                this.tagTypeTags[tagTypeId].push(tagToDelete);
                this.packageTags[tagTypeId].tagsList = tags.filter(tag => tag.name !== tagToDelete.name);
                this.addedTags = this.addedTags.filter(tag => tag.name !== tagObj.name);
                return;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-tag-dialog/add-tag-dialog.component.ts